import type { Option } from "@/Components/UI/TcSelect.vue";

export const TEXT_TYPE_OPTIONS: Option<number>[] = [
  { label: "documents.editor.text_type.paragraph", value: 0 },
  { label: "documents.editor.text_type.heading_1", value: 1 },
  { label: "documents.editor.text_type.heading_2", value: 2 },
  { label: "documents.editor.text_type.heading_3", value: 3 },
  { label: "documents.editor.text_type.heading_4", value: 4 },
];

export const ZOOM_OPTIONS: Option<number>[] = [
  { label: "25%", value: 0.25 },
  { label: "50%", value: 0.5 },
  { label: "75%", value: 0.75 },
  { label: "100%", value: 1 },
  { label: "125%", value: 1.25 },
  { label: "150%", value: 1.5 },
  { label: "175%", value: 1.75 },
  { label: "200%", value: 2 },
];

export const FONT_OPTIONS: Option<string>[] = [
  { label: "documents.editor.text_font.arial", value: "Arial" },
  { label: "documents.editor.text_font.calibri", value: "Calibri" },
  { label: "documents.editor.text_font.comic_sans", value: "Comic Sans MS" },
  { label: "documents.editor.text_font.courier_new", value: "Courier New" },
  { label: "documents.editor.text_font.georgia", value: "Georgia" },
  { label: "documents.editor.text_font.helvetica", value: "Helvetica" },
  { label: "documents.editor.text_font.impact", value: "Impact" },
  { label: "documents.editor.text_font.lucida_grande", value: "Lucida Grande" },
  { label: "documents.editor.text_font.lucida_console", value: "Lucida Console" },
  { label: "documents.editor.text_font.palatino_linotype", value: "Palatino Linotype" },
  { label: "documents.editor.text_font.tahoma", value: "Tahoma" },
  { label: "documents.editor.text_font.times_new_roman", value: "Times New Roman" },
  { label: "documents.editor.text_font.trebuchet_ms", value: "Trebuchet MS" },
  { label: "documents.editor.text_font.verdana", value: "Verdana" },
];

export const FREE_CUSTOM_INPUT_VALUE = "---";
export const CUSTOM_INPUT_OPTIONS: Option<string>[] = [
  {
    label: "documents.editor.actions.add_input_modal.professional.username",
    value: "professional.username",
  },
  { label: "documents.editor.actions.add_input_modal.professional.email", value: "professional.email" },
  {
    label: "documents.editor.actions.add_input_modal.professional.language",
    value: "professional.language",
  },
  { label: "documents.editor.actions.add_input_modal.professional.gender", value: "professional.gender" },
  { label: "documents.editor.actions.add_input_modal.professional.age", value: "professional.age" },
  {
    label: "documents.editor.actions.add_input_modal.professional.location",
    value: "professional.location",
  },
  {
    label: "documents.editor.actions.add_input_modal.professional.full_name",
    value: "professional.full_name",
  },
  {
    label: "documents.editor.actions.add_input_modal.professional.phone_number",
    value: "professional.phone_number",
  },
  {
    label: "documents.editor.actions.add_input_modal.professional.professional_license_number",
    value: "professional.professional_license_number",
  },
  { label: "documents.editor.actions.add_input_modal.client.nif", value: "client.nif" },
  { label: "documents.editor.actions.add_input_modal.client.address", value: "client.address" },
  { label: "documents.editor.actions.add_input_modal.client.username", value: "client.username" },
  { label: "documents.editor.actions.add_input_modal.client.phone", value: "client.phone" },
  { label: "documents.editor.actions.add_input_modal.client.email", value: "client.email" },
  { label: "documents.editor.actions.add_input_modal.client.birthday", value: "client.birthday" },
  { label: "documents.editor.actions.add_input_modal.free", value: FREE_CUSTOM_INPUT_VALUE },
  { label: "documents.editor.actions.add_input_modal.user.language", value: "user.language" },
  { label: "documents.editor.actions.add_input_modal.user.gender", value: "user.gender" },
  { label: "documents.editor.actions.add_input_modal.user.age", value: "user.age" },
  { label: "documents.editor.actions.add_input_modal.user.full_name", value: "user.full_name" },
];
